import { Tooltip } from 'antd'
import type { ReactNode } from 'react'

import type { PriceSource } from '@/types'
import {
  getPriceSourceText,
  getUpdatedAtTitle,
} from '@/utils/products/offerAvailability'

import TooltipLines from '../TooltipLines/TooltipLines'

interface UpdatedAtTooltipProps {
  updatedAt: string | null | undefined
  kind: 'price' | 'stock'
  priceSource?: PriceSource
  children: ReactNode
}

function UpdatedAtTooltip({
  updatedAt,
  kind,
  priceSource,
  children,
}: UpdatedAtTooltipProps) {
  const lines = [
    getUpdatedAtTitle(kind, updatedAt),
    getPriceSourceText(priceSource),
  ]
  if (lines.every((line) => line === undefined)) return <>{children}</>

  return (
    <Tooltip title={<TooltipLines lines={lines} />}>
      <span>{children}</span>
    </Tooltip>
  )
}

export default UpdatedAtTooltip
